import { Directive, ElementRef, Input, OnChanges, Renderer2, OnInit, AfterContentInit  } from '@angular/core';
import {LocalesService, ConfigService} from '../templates/Locale/locales.service';
import { Locale } from '../templates/Locale/Locale';

@Directive({
    selector: '[localeplaceholder]'
})

export class LocalePlaceholderDirective implements OnChanges {
  @Input('localeplaceholder') localePlaceHolderKey: string;
  @Input('localeview') localePlaceHolderView: string; 

    constructor(private el: ElementRef, private renderer2: Renderer2, private localeService: LocalesService, private configService: ConfigService) { }

  ngOnChanges(): void {      
      let localeValue = "";
      this.localeService.getLocalesByLang(this.configService.languagerequested)
        .subscribe((locales: Locale[]) => {
            let localeMatches = locales.filter(item => {
                return item.key === this.localePlaceHolderKey && (item.view == null || item.view == undefined || item.view === this.localePlaceHolderView);
            });

            if (localeMatches.length > 0) {
                localeValue = localeMatches[0].value;    
                this.renderer2.setAttribute(
                    this.el.nativeElement, 'placeholder', localeValue
                );   
            }
        },
        err => { },
        () => {
            this.renderer2.setAttribute(
                this.el.nativeElement, 'placeholder', localeValue
            );    
        });    
  }
}

